import { requests } from "@/functional/api/api.ts";
import isOffline from "@/functional/isOffline.ts";
import chainSleep from "@/functional/chainSleep.ts";
import type { RecoveryCodeDetails } from "@/models/recoveryCodeDetails.ts";
import type { UserLoginResponse } from "@/functional/api/apiUsers.ts";
import generateUserLoginResponse from "@/functional/generateUserLoginResponse.ts";

let details: (userId: string) => Promise<RecoveryCodeDetails> = (userId) =>
  requests.get<RecoveryCodeDetails>(`recoveryCodes/details`, { userId });

if (isOffline) {
  details = async () => {
    return Promise.resolve({
      activeCodeCount: 0,
    } as RecoveryCodeDetails).then(chainSleep(100, 3000));
  };
}

let register: (userId: string) => Promise<string[]> = (userId) =>
  requests.post<string[]>(`recoveryCodes`, { userPublicId: userId });

if (isOffline) {
  register = async () => {
    return Promise.resolve([
      "recovery_code_1",
      "recovery_code_2",
      "recovery_code_3",
    ]).then(chainSleep(100, 3000));
  };
}

export interface RecoveryCodeLoginRequest {
  email: string;
  recoveryCode: string;
}

let login: (
  loginDetails: RecoveryCodeLoginRequest,
) => Promise<UserLoginResponse> = (loginDetails) =>
  requests.post<UserLoginResponse>(`recoveryCodes/login`, loginDetails);

if (isOffline) {
  login = async () =>
    Promise.resolve(generateUserLoginResponse()).then(chainSleep(100, 3000));
}

export default {
  details,
  register,
  login,
};
